import { apiClient } from '~/api/client';

type Params = {
  county: string;
  state: string;
};

type IndexResponse = string[];

export const index = async (params: Params) =>
  apiClient.get<IndexResponse>(`/addresses/counties`, { params });
